import { MailFilled } from '@ant-design/icons';
import { websitetopLandingsSelector } from '@mm/state/selectors/websiteReportSummarySelector';
import { Table } from 'antd';
import React from 'react';
import { useSelector } from 'react-redux';
import { LLRActionButtons } from '../LLRActionButtons/LLRActionButtons';
import {
  beautifyNumber,
  WEB_TRAFFIC_GROWTH_WITH_MOBILEMONKEY,
} from '../WebsiteReportSummary/constants';
import styles from './WebsiteTrafficList.module.css';

export const WebsiteTrafficList = ({
  websiteURL,
  traffic,
  onClick,
}: {
  websiteURL: string;
  traffic: number;
  onClick: () => void;
}) => {
  const landings = useSelector(websitetopLandingsSelector);
  const filteredLandings = landings?.filter(
    landing => landing.page !== websiteURL,
  );

  const tableColumns = [
    {
      title: 'Name',
      dataIndex: 'name',
      render: name => {
        const names = name?.split(' ');
        return name ? (
          <div className={styles.dataRow}>
            {names?.[0]} <span className={styles.blur}>{names?.[1]}</span>
          </div>
        ) : (
          <div className={styles.column}>
            <div className={styles.skeleton} />
            <div className={styles.skeleton} />
          </div>
        );
      },
    },
    {
      title: 'Email',
      dataIndex: 'email',
      render: email => (
        <div className={styles.emailRow}>
          <MailFilled className={styles.emailIcon} />
          {email ? email : <div className={styles.skeleton} />}
        </div>
      ),
    },
    {
      title: 'Phone',
      dataIndex: 'phone',
      render: phone => (
        <div className={styles.dataRow}>
          {phone ? phone : <div className={styles.skeleton} />}
        </div>
      ),
    },
    {
      title: 'Landing Page URL',
      dataIndex: 'landingPage',
      render: landingPage => (
        <div className={styles.domainName}>
          {landingPage ? landingPage : <div className={styles.skeleton} />}
        </div>
      ),
    },
    {
      title: 'Page views',
      dataIndex: 'views',
      render: views => (
        <div className={styles.dataRow}>
          {views ? views : <div className={styles.skeleton} />}
        </div>
      ),
    },

    {
      title: 'Time spent on site',
      dataIndex: 'time',
      render: time => (
        <div className={styles.dataRow}>
          {time ? time : <div className={styles.skeleton} />}
        </div>
      ),
    },
    {
      title: 'Clicks',
      dataIndex: 'clicks',
      render: clicks => (
        <div className={styles.dataRow}>
          {clicks ? clicks : <div className={styles.skeleton} />}
        </div>
      ),
    },
  ];

  const tableData = [
    {
      key: 1,
      name: 'Michael Johnson',
      email: 'michael...',
      phone: '+1419...',
      landingPage: filteredLandings?.[0]?.page || websiteURL,
      views: 12,
      time: '28:14',
      clicks: 18,
    },
    {
      key: 2,
      name: 'Jamie Schwartz',
      email: 'jamie78...',
      phone: '+1215...',
      landingPage: filteredLandings?.[0]?.page || websiteURL,
      views: 7,
      time: '12:00',
      clicks: 12,
    },
    {
      key: 3,
      name: 'Kirsten Snyder',
      email: 'kirst.ceo...',
      phone: '+1484...',
      landingPage: filteredLandings?.[1]?.page || websiteURL,
      views: 8,
      time: '15:47',
      clicks: 14,
    },
    {
      key: 4,
      skeleton: true,
    },
    {
      key: 5,
      skeleton: true,
    },
  ];

  return (
    <div className={styles.container}>
      <div className={styles.headerContainer}>
        <div className={styles.header}>
          <span className={styles.link}>{websiteURL}</span>'s website visitor
          traffic list
        </div>
        Here is a preview of what your anonymous website visitor contact list
        would look like every month!
      </div>
      <Table
        columns={tableColumns}
        dataSource={tableData}
        pagination={false}
        className={styles.table}
      />

      <div className={styles.footer}>
        <div>
          Based on our analysis,{' '}
          <span className={styles.link}>{websiteURL}</span> has{' '}
          {beautifyNumber(traffic)} visitors per month.
          <div>
            Customers.ai could{' '}
            <span className={styles.importantHighligted}>
              capture an additional{' '}
              {beautifyNumber(traffic * WEB_TRAFFIC_GROWTH_WITH_MOBILEMONKEY)}{' '}
              email{' '}
            </span>{' '}
            contacts per month from your traffic.
          </div>
        </div>
        <LLRActionButtons onClick={onClick} websiteURL={websiteURL} />
      </div>
    </div>
  );
};
